// The city a reader knows the workspace clock by, in every UI language — "Bangkok" / "曼谷" / "กรุงเทพฯ".
// UI strings say "$t(tz_city) time" (i18next nesting), so no call site passes a zone and no string names
// a city. Names live in src/i18n/mt/zone.ts (key 'tzc_' + IANA id); a zone not listed there prints its
// English city. Fed from /api/me (store/index.ts, beside setBrand); before that, the browser's zone.
// Imports nothing but i18next, so src/i18n/index.ts can call it without an import cycle.
import i18next from 'i18next';

let current = '';
const LANGS = ['en', 'zh', 'th'];
const cityOf = (z: string): string => (z.includes('/') ? z.slice(z.lastIndexOf('/') + 1) : z).replace(/_/g, ' ');

export function setZoneCity(zone?: string | null): void {
  let z = String(zone || '').trim();
  if (!z) { try { z = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'; } catch { z = 'UTC'; } }
  if (z === current || !i18next.isInitialized) return;
  const key = 'tzc_' + z.replace(/[^A-Za-z]/g, '_');
  for (const l of LANGS) {
    const name = i18next.getResource(l, 'translation', key) || i18next.getResource('en', 'translation', key) || cityOf(z);
    i18next.addResource(l, 'translation', 'tz_city', String(name));
  }
  const first = !current;
  current = z;
  if (first) return;   // the initial call happens before anything renders
  Promise.resolve().then(() => { try { i18next.emit('languageChanged', i18next.language); } catch { /* nothing mounted */ } });
}
